import { CandidateListViews } from '@/shared/constants/candidate/CandidateListViews'

const CandidateListPageSize = 60

/**
 * Request model for `POST /candidate/queryCandidates`.
 *
 * @typedef {Object} CandidateQueryRequestDTO
 * @property {Array<number>} clientIds - Array of client IDs to filter candidates.
 * @property {CandidateListViews} grouping - CandidateListViews value, determines result grouping (e.g., Preferred, All).
 * @property {number|null} sort - Optional. Sort option enum (when sort UI is enabled).
 * @property {string} searchTerm - Optional. Free text search applied to candidate attributes.
 * @property {boolean|null} bookable - Optional. If true, filters to only bookable candidates.
 * @property {Array<number>} certificationIds - Optional. Filter by required certification IDs.
 * @property {Array<number>} clientGroupIds - Optional. Filter by client group IDs.
 * @property {Array<number>} candidateTypeIds - Optional. Filter by educator type IDs.
 * @property {number} pageNumber - Page number for pagination (1-based).
 * @property {number} pageSize - Number of candidates per page (default 60).
 */
export class CandidateQueryRequestDTO {
  constructor({
    clientIds,
    grouping,
    sort,
    searchTerm,
    bookable,
    certificationIds,
    clientGroupIds,
    typeIds,
    pageNumber,
    pageSize,
  } = {}) {
    this.clientIds = clientIds ?? []
    this.grouping = grouping ?? CandidateListViews.All
    this.sort = sort ?? null
    this.searchTerm = searchTerm ?? ''
    this.bookable = bookable ?? null
    this.certificationIds = certificationIds ?? []
    this.clientGroupIds = clientGroupIds ?? []
    this.candidateTypeIds = typeIds ?? []
    this.pageNumber = pageNumber ?? 1
    this.pageSize = pageSize ?? CandidateListPageSize
  }
}
